import Component from './account'

export default Component